export enum DocumentType {
    Unknown = 0,
    Presentation = 1,
    Document = 2,
    Table = 3,
    Picture = 4,
}

export const documentTypeFilterFields: Array<{ value: number; label: string }> = [
    { value: DocumentType.Unknown, label: "Nepoznato" },
    { value: DocumentType.Presentation, label: "Prezentacija" },
    { value: DocumentType.Document, label: "Dokument" },
    { value: DocumentType.Table, label: "Tablica" },
    { value: DocumentType.Picture, label: "Slika" },
];
